"use client";

import Box from "@mui/material/Box";
import type { PayloadMediaUpload } from "@portal/app/_server/services/formFunnel/payloadTypes";
import { getFormFunnelImageProps } from "./formFunnelMedia";

interface FormFunnelBannerImageProps {
  image?: PayloadMediaUpload | string;
  loading?: "eager" | "lazy";
}

export function FormFunnelBannerImage({ image, loading }: FormFunnelBannerImageProps) {
  const imageProps = getFormFunnelImageProps(image);
  if (!imageProps) return null;

  return (
    <Box
      data-testid="form-funnel-banner-image"
      sx={{
        width: "100%",
        maxHeight: { xs: 240, md: 420 },
        mb: { xs: 3, md: 4 },
        overflow: "hidden",
        borderRadius: { xs: 2, md: 3 },
        bgcolor: "dream.grayLighter",
      }}
    >
      <img
        src={imageProps.src}
        loading={loading}
        alt={imageProps.alt}
        width={imageProps.width}
        height={imageProps.height}
        style={{
          display: "block",
          width: "100%",
          height: "auto",
          maxHeight: 420,
          objectFit: "cover",
        }}
      />
    </Box>
  );
}
